/* tslint:disable */
/* eslint-disable */
/**
 * NinjaAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PackageFileSchema
 */
export interface PackageFileSchema {
    /**
     * 
     * @type {number}
     * @memberof PackageFileSchema
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof PackageFileSchema
     */
    fileName: string;
}

/**
 * Check if a given object implements the PackageFileSchema interface.
 */
export function instanceOfPackageFileSchema(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "fileName" in value;

    return isInstance;
}

export function PackageFileSchemaFromJSON(json: any): PackageFileSchema {
    return PackageFileSchemaFromJSONTyped(json, false);
}

export function PackageFileSchemaFromJSONTyped(json: any, ignoreDiscriminator: boolean): PackageFileSchema {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'fileName': json['file_name'],
    };
}

export function PackageFileSchemaToJSON(value?: PackageFileSchema | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'file_name': value.fileName,
    };
}

